import { makeStyles } from "@material-ui/core";
import React from "react";

import { FullSite } from "../../../../dtos/site";
import { StandardTable } from "../../../shared/table";

import { StatsTableRow } from "./StatsTableRow";
import { StatsKey } from "./types";

const useStyles = makeStyles(() => ({
    tableContainer: {
        width: "100%",
        overflowX: "auto",
    },
    table: {
        "& tr td": {
            "&:first-child": {
                fontWeight: "normal", // overrides styles of StandartTable
            },
        },
    },
    statsKeyTh: {
        width: "70%",
    },
}));

interface Props {
    sitesByStatsKey: { [key in StatsKey]?: FullSite[]; };
    itemLabel?: string;
    attentionToCount?: boolean;
    dealerId: number | null;
}

export function StatsTable({
    sitesByStatsKey,
    itemLabel = "site",
    attentionToCount = false,
    dealerId,
}: Props) {
    const classes = useStyles();

    return (
        <div className={classes.tableContainer}>
            <StandardTable className={classes.table}>
                <thead>
                    <tr>
                        <th className={classes.statsKeyTh}>Type</th>
                        <th style={{ textAlign: "center" }}>Count</th>
                    </tr>
                </thead>

                <tbody>
                    {(Object.keys(sitesByStatsKey) as (keyof typeof sitesByStatsKey)[])
                        .map(statsKey => (
                            <StatsTableRow
                                key={statsKey}
                                statsKey={statsKey}
                                sites={sitesByStatsKey[statsKey] || []}
                                itemLabel={itemLabel}
                                attentionToCount={attentionToCount}
                                dealerId={dealerId}
                            />
                        ))}
                </tbody>
            </StandardTable>
        </div>
    );
}